<template>
  <v-form v-model="dataIsValid">
    <v-row>
      <v-col cols="6" md="4" offset-sm="1">
        <div class="address-title">
          <div class="mb-3 body-1 font-weight-medium">Адрес регистрации заявителя</div>
        </div>
        <address-form
          addressType="802740000"
          :income="registrationsAddress"
          :address="addresses.length > 0 ? addresses[0] : null"
          @transferData="setRegistrationsAddress"
        ></address-form>
      </v-col>
      <v-col cols="6" md="4" offset-sm="2">
        <div class="address-title">
          <div class="mb-3 body-1 font-weight-medium">Адрес доставки квитанции</div>
          <v-checkbox v-model="isEqualRegAddress" label="Совпадает с адресом регистрации"></v-checkbox>
        </div>
        <address-form
          addressType="802740001"
          :disabled="isEqualRegAddress"
          :income="deliveryAddress"
          :address="addresses.length > 0 ? addresses[1] : null"
          @transferData="setDeliveryAddress"
        ></address-form>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
  import AddressForm from "./partial/AddressForm";

  export default {
    props: ["income", 'addresses'],
    components: {
      AddressForm
    },
    data: () => ({
      // DATA
      isEqualRegAddress: false,
      registrationsAddress: null,
      deliveryAddress: null,
      dataIsValid: false
    }),
    methods: {
      transferData() {
        this.$emit("transfer", {
          isEqualRegAddress: this.isEqualRegAddress,
          registrationsAddress: this.registrationsAddress,
          deliveryAddress: this.deliveryAddress
        });
      },
      setRegistrationsAddress(payload) {
        this.registrationsAddress = payload;
      },
      setDeliveryAddress(payload) {
        this.deliveryAddress = payload;
      }
    },
    created() {
      let keys = Object.keys(this.income);
      keys.forEach(key => {
        this[key] = this.income[key];
      });
    },
    watch: {
      isEqualRegAddress: {
        immediate: true,
        handler: function (value) {
          if (value) {
            this.deliveryAddress = {
              ...this.registrationsAddress,
              addressType: "802740001"
            };
          }
        }
      },
      dataIsValid: {
        immediate: true,
        handler: function (value) {
          this.$emit("lockFwdBtn", !value);
        }
      },
      registrationsAddress: {
        immediate: true,
        handler: function (value) {
          if (this.isEqualRegAddress) {
            this.deliveryAddress = {
              ...value,
              addressType: "802740001"
            };
          }
        }
      }
    }
  };
</script>

<style scoped>
  .address-title {
    height: 100px;
  }
</style>
